!(function(global){
	function Point(x, y){
		this.x = x;
		this.y = y;
	}

	function OnePageScroll(wrapperID){

		var that = this;
		this.lastScrollTime = new Date().getTime()-1500;
		this.wrapper = _dom('#' + wrapperID);

		this.rect = {
			width: window.innerWidth || document.documentElement.clientWidth,
			height: window.innerHeight || document.documentElement.clientHeight
		};
		this.activeSlide = 0;
		this.slideCount = _dom('.page').length;
		this.position = new Point(0, 0);
		this.duration = 0;
		this.disabled = false;

		this._generateNavigation();

		this.on('slide:goTo', function(slideNumber){
			this._goTo(slideNumber);
		});

		this.on('activeSlide:change', function(slideNumber){
			window.location.hash = slideNumber+1;
			this._changeNavIcon(slideNumber);
			this._render(new Point(0, -(slideNumber * this.rect.height)), 1000);
		});

		this.on('duration:change', this._setDuration, this);
		this.on('position:change', this._setPosition, this);
		this.on('rect:change', function(rect){
			this.set('duration', 0);
			this.set('position', new Point(0, - this.activeSlide * rect.height));
		});

		this.on('slide:next', function(){
			this._goTo(this.activeSlide + 1);
		});
		this.on('slide:prev', function(){
			this._goTo(this.activeSlide - 1);
		});

		_dom(window).on('resize', function(){
			if(Modernizr.touch)window.scrollTo(0, 0);
			that.set('rect', {
				width: window.innerWidth || document.documentElement.clientWidth,
				height: window.innerHeight || document.documentElement.clientHeight
			});
		});

		//биндим изменение слайда на колесо прокрутки
		this.wrapper.on('mousewheel MozMousePixelScroll wheel', function(event){
			var delta = event.deltaY || event.detail || event.wheelDelta,
				currentTime = new Date().getTime();

			if(currentTime - that.lastScrollTime < 1400){
				return
			}
			that.lastScrollTime = currentTime;
			that.trigger('slide:' + (delta > 0 ? 'prev' : 'next'), {}, that);
		});

		//биндим изменение слайда на клавишы вверх-вниз
		_dom(document.body).on('keydown', function(event){
			switch(event.keyCode){
				case 40:
					that.trigger('slide:next', {}, that);
					break;
				case 38:
					that.trigger('slide:prev', {}, that);
					break;
				default:
					break;
			}
			return null;
		});

		//отключаем нативный скролл в тач девайсах
//		this.wrapper.on('touchmove', function(){
//			event.preventDefault();
//		}, false);


		var dragStart = function(){
			that.trigger('slide:animationStart', that.activeSlide, that);
			that.startPosition = that.wrapper.el.getBoundingClientRect().top;
		};

		var drag = function(){
			if((that.activeSlide === 0 && event.gesture.deltaY >= 0) || (that.activeSlide-that.slideCount+1 === 0 && event.gesture.deltaY <= 0)){
				return
			}
			that._render(new Point(0, (that.startPosition + event.gesture.deltaY)), 0);
		};

		var dragEnd = function(){
			if(Math.abs(event.gesture.deltaY) < 60){
				that._render(new Point(0, -(that.activeSlide * that.rect.height)), 200);
				that.trigger('slide:animationCancel', that.activeSlide, that);
			}else{
				that.trigger('slide:' + (event.gesture.deltaY > 0 ? 'prev' : 'next'), {}, that);
			}
		};

		//обработка драга
		this.startPosition = 0;

		this.parentElement.on('dragstart', dragStart);
		this.parentElement.on('drag', drag);
		this.parentElement.on('dragend', dragEnd);

		this.wrapper.on('dragstart', dragStart);
		this.wrapper.on('drag', drag);
		this.wrapper.on('dragend', dragEnd);
	}

	OnePageScroll.prototype = new Events();
	OnePageScroll.prototype.constructor = OnePageScroll;

	OnePageScroll.prototype._generateNavigation = function(){
		var that = this,
			childs = _dom('.page');

		this.parentElement = _newEl('ul',{
				'class': 'onePageScrollNavigation',
				'styles': {
					'margin-top': '-' + ((childs.length * 22)/2) + 'px'
				}
			}).insert(document.body);

		_.each(childs, function(item, i){
			var childElement = _newEl('li',{}).insert(this.parentElement);
			_newEl('span',{
				'id': i + 'NavIcon',
				'class': i === 0 ? 'emptyCircleIcon' : 'dotIcon'
			}).insert(childElement);

			_newEl('span',{
				'class': 'navName'
			}).setText(item.attr('data-name')).insert(childElement);

			childElement.on('tap', function(){
				that.trigger('slide:goTo', i, this);
			});
		}, this);

	};

	OnePageScroll.prototype._goTo = function(slideNumber){
		if((slideNumber < 0 || slideNumber >= this.slideCount) || this.disabled){
			return;
		}

		this.set('activeSlide', slideNumber);
	};

	OnePageScroll.prototype._render = function(point, time){
		if(this.disabled){
			return
		}

		time = time || 0;
		var that = this;

		that.set('duration', time);
		that.set('position', point);
	};

	OnePageScroll.prototype._changeNavIcon = function(){
		_dom('.emptyCircleIcon')[0].setClass('dotIcon');
		_dom('#' + this.activeSlide + 'NavIcon').setClass('emptyCircleIcon');
	};

	OnePageScroll.prototype._setDuration = function(duration){
		this.wrapper.animationDuration(duration);
	};

	OnePageScroll.prototype._setPosition = function(position){
		this.wrapper.transform(position);
	};

	OnePageScroll.prototype.disableSlideshow = function(){
		this.parentElement.css({
			'display': 'none'
		});

		this.disabled = true;
	};

	OnePageScroll.prototype.enableSlideshow = function(){
		this.parentElement.css({
			'display': 'block'
		});

		this.disabled = false;
	};

	global.OnePageScroll = OnePageScroll;
})(this);